import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import lodashMap from 'lodash/map';
import lodashFindIndex from 'lodash/findIndex';
import lodashFilter from 'lodash/filter';
import { Toolbar, Data } from 'react-data-grid-addons';
import { SkyLightStateless } from 'react-skylight';
import { Translate, I18n } from 'react-redux-i18n';
import { Grid, Row, Col, Panel, Button, Breadcrumb } from 'react-bootstrap';
import NotificationSystem from 'react-notification-system';

// import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../Widgets/spinner';
import SpinnerButton from '../Common/SpinnerButton';
import { RowRenderer } from '../Common/rowRenderer';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ConfirmActionModal from '../Common/confirmActionModal';
import CreateGroupModal from './createGroupModal';

import {
  fetchCustomers,
  fetchCustomerGroups,
  createGroup,
  deleteGroup,
  fetchCustomerGroupsDetail,
  saveCustomerList,
} from '../../actions/groupList_actions';

const contextTypes = {
  router: React.PropTypes.shape({}),
};

class GroupList extends Component {
  constructor() {
    super();
    this.state = {
      // tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton,

      isLoadingCustomers: false,
      isLoadingGroups: false,
      isLoadingDeleteGroup: false,
      isLoadingCreateGroup: false,
      isLoadingGroupDetails: false,
      isLoadingSaveCustomerList: false,

      currentGroupId: '',
      currentGroupName: '',
      groupToDeleteId: '',
      confirmModalOpen: false,
      createModalOpen: false,
      case: '',
      caseAction: null,
      confirmTitle: '',
      groups: {
        rows: [],
        filters: {},
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
      },

      customers: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },

      allCustomers: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },

      allCustomerRowsOriginal: [],
    };
  }


  componentDidMount() {
    // window.addEventListener('resize', this.handleResize);
    this._notificationSystem = this.refs.notificationSystem;
    this.handleFetchCustomerGroups();
    this.handleFetchCustomers();
  }

  _notificationSystem = null;

  handleFetchCustomers = () => {
    const handleSuccess = (response) => {
      const allCustomers = { ...this.state.allCustomers, rows: response.data || [], filters: {} };
      this.setState({
        isLoadingCustomers: false,
        allCustomers,
        allCustomerRowsOriginal: response.data || [],
      });
    };

    const handleFailure = (error) => {
      this.setState({ isLoadingCustomers: false });
      alert(JSON.stringify(error));
    };

    this.setState({ isLoadingCustomers: true }, () => {
      fetchCustomers(handleSuccess, handleFailure);
    });
  }

  handleFetchCustomerGroups = () => {
    const handleSuccess = (response) => {
      const { selectedRows } = this.state.groups;
      const rows = response.data;
      if (selectedRows.length > 0) {
        lodashMap(rows, (row) => {
          if (row.CustomerGroup_id === selectedRows[0].CustomerGroup_id) {
            row.isSelected = true;
          }
        });
      }
      const groups = { ...this.state.groups, rows, filters: {} };
      this.setState({
        isLoadingGroups: false,
        groups,
      });
    };

    const handleFailure = (error) => {
      this.setState({ isLoadingGroups: false });
      alert(JSON.stringify(error));
    };

    this.setState({ isLoadingGroups: true }, () => {
      fetchCustomerGroups(handleSuccess, handleFailure);
    });
  }

  handleFetchCustomerGroupDetails = () => {
    const handleSuccess = (response) => {
      const rows = response.data.Customers || [];
      const customers = { ...this.state.customers, rows, filters: {} };
      this.setState({
        isLoadingGroupDetails: false,
        customers,
      });
    };

    const handleFailure = (error) => {
      this.setState({ isLoadingGroupDetails: false });
      alert(JSON.stringify(error));
    };
    const { selectedRows } = this.state.groups;
    if (selectedRows.length === 0) {
      return;
    }

    this.setState({ isLoadingGroupDetails: true }, () => {
      fetchCustomerGroupsDetail(selectedRows[0].CustomerGroup_id, handleSuccess, handleFailure);
    });
  }

  handleSaveCustomerList = () => {
    const handleSuccess = () => {
      this.setState({ isLoadingSaveCustomerList: false }, () => {
        this.handleAddNotification('save_successful', 'success');
        this.handleFetchCustomerGroups();
        this.handleFetchCustomers();
      });
    };

    const handleFailure = (error) => {
      this.setState({ isLoadingSaveCustomerList: false }, () => {
        alert(JSON.stringify(error));  
      });
    };

    const { customers, currentGroupName, currentGroupId } = this.state;
    const customerIds = lodashMap(customers.rows, 'Customer_id');
    this.setState({ isLoadingSaveCustomerList: true }, () => {
      saveCustomerList(customerIds, currentGroupName, currentGroupId, handleSuccess, handleFailure);
    });
  }

  handleDeleteGroup = () => {
    const handleSuccess = () => {
      this.setState({ isLoadingDeleteGroup: false }, () => {
        const { selectedRows } = this.state.groups;
        const { groupToDeleteId } = this.state;
        if (selectedRows.length > 0 && selectedRows[0].CustomerGroup_id === groupToDeleteId) {
          const customers = { ...this.state.customers, rows: [], filters: {} };
          this.setState({ customers, currentGroupId: '', currentGroupName: '' });
        }
        this.handleAddNotification('delete_successful', 'success');
        this.handleFetchCustomerGroups();
      });
    };

    const handleFailure = (error) => {
      this.setState({ isLoadingDeleteGroup: false });
      alert(JSON.stringify(error));
    };

    this.setState({ isLoadingDeleteGroup: true }, () => {
      deleteGroup(this.state.groupToDeleteId, handleSuccess, handleFailure);
    });
  }

  handleAddGroup = (currentGroupName) => {
    const handleSuccess = () => {
      this.setState({ isLoadingCreateGroup: false }, () => {
        this.closeModalCreate();
        this.handleFetchCustomerGroups();
      });
    };

    const handleFailure = (error) => {
      this.setState({ isLoadingCreateGroup: false });
      alert(JSON.stringify(error));
    };

    this.setState({ isLoadingCreateGroup: true }, () => {
      createGroup(currentGroupName, handleSuccess, handleFailure);
    });
  }

  handleAddNotification(title, level) {
    this._notificationSystem.addNotification({
      title: <Translate value={title} />,
      level,
    });
  }

  handleCurrentGroupNameChange = (event) => {
    this.setState({ currentGroupName: event.target.value });
  }

  handleOnFocus = (event) => {
    event.target.select();
  }

  openModalConfirm = () => {
    this.setState({ confirmModalOpen: true });
  }

  closeModalConfirm = () => {
    this.setState({
      confirmModalOpen: false,
      case: '',
      caseAction: null,
      confirmTitle: '',
    });
  }

  openModalCreate = () => {
    this.setState({ createModalOpen: true });
  }

  closeModalCreate = () => {
    this.setState({ createModalOpen: false });
  }

  removeGroup(groupToDeleteId) {
    const confirmTitle = (<Translate value="confirm_delete" />);
    this.setState({
      confirmModalOpen: true,
      groupToDeleteId,
      case: 'deleteGroup',
      caseAction: this.handleDeleteGroup,
      confirmTitle,
    });
  }

  removeCustomer(customerId, customerNum) {
    let customerToRemove;
    const customerRows = lodashFilter(this.state.customers.rows, (customer) => {
      if (customer.CustomerNum === customerNum) {
        customerToRemove = customer;
        return false;
      }
      return true;
    });
    const allCustomerRows = JSON.parse(JSON.stringify(this.state.allCustomers.rows));
    const found = lodashFindIndex(allCustomerRows, row => row.CustomerNum === customerNum);
    if (found === -1) {
      allCustomerRows.push(customerToRemove);
    }
    const customers = { ...this.state.customers, rows: customerRows };
    const allCustomers = { ...this.state.allCustomers, rows: allCustomerRows };
    this.setState({ customers, allCustomers });
  }

  // handleResize = () => {
  //   this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton });
  // }

  moveToCustomerGroup = (event) => {
    if (!this.state.currentGroupId) {
      alert(I18n.t('please_select_group'));
      return;
    }
    const invalid = lodashFindIndex(this.state.customers.rows, row => row.CustomerNum === event.CustomerNum);
    if (invalid !== -1) {
      alert(I18n.t('this_customer_is_already_in_the_group'));
      return;
    }
    const customerRows = JSON.parse(JSON.stringify(this.state.customers.rows));
    const allCustomerRows = lodashFilter(this.state.allCustomers.rows, customer => customer.CustomerNum !== event.CustomerNum);
    customerRows.push(event);
    const customers = { ...this.state.customers, rows: customerRows };
    const allCustomers = { ...this.state.allCustomers, rows: allCustomerRows };
    this.setState({ customers, allCustomers });
  }

  renderCustomerList() {
    const that = this;
    if (this.state.isLoadingGroups || this.state.isLoadingDeleteGroup || this.state.isLoadingCreateGroup) {
      return <Spinner />;
    }

    const getRows = () => {
      const rows = Data.Selectors.getRows(this.state.groups);
      return rows;
    };

    const getSize = () => {
      const rowLength = getRows().length;
      return rowLength;
    };

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const groups = { ...this.state.groups, sortColumn, sortDirection };
      this.setState({ groups });
    };

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      newRows.map((r) => {
        r.isSelected = false;
      });
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
      });
      const groups = {
        ...this.state.groups,
        rows: newRows,
        selectedRows: [rows[0].row],
      };
      const allCustomers = { ...this.state.allCustomers, rows: this.state.allCustomerRowsOriginal, filters: {} };
      const customers = { ...this.state.customers, filters: {} };
      this.setState({
        groups,
        customers,
        allCustomers,
        currentGroupId: rows[0].row.CustomerGroup_id,
        currentGroupName: rows[0].row.Name,
      }, () => {
        this.handleFetchCustomerGroupDetails();
      });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.groups.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const groups = { ...this.state.groups, filters: newFilters };
      this.setState({ groups });
    };

    const onClearFilters = () => {
      const groups = { ...this.state.groups, filters: {} };
      this.setState({ groups });
    };

    const IsVariableFormatter = React.createClass({
      render() {
        return (
          <span>
            <Button
              bsStyle="danger"
              className="textAlignStyle"
              style={{ height: '23px', width: '39px', padding: '0px' }}
              onClick={() => {
                const customerGroupId = this.props.dependentValues.CustomerGroup_id;
                that.removeGroup(customerGroupId);
              }}
            >
              X
            </Button>
          </span>
        );
      },
    });

    const columns = [
      {
        name: <Translate value="del" />,
        width: 50,
        formatter: IsVariableFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'Name',
        name: <Translate value="group_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
      },
    ];
    return (
      <Row>
        <Col sm={12}>
          <Button
            bsStyle="primary"
            className="add-group-button"
            onClick={that.openModalCreate}
          >
            <Translate value="+" />
          </Button>
        </Col>
        <Col sm={12}>
          <div id="GroupList-dataGrid1">
            <ReactDataGrid
              rowKey="Customer_id"
              onGridSort={handleGridSort}
              columns={columns}
              rowHeight={25}
              rowGetter={rowGetter}
              toolbar={<Toolbar enableFilter />}
              onClearFilters={onClearFilters}
              onAddFilter={handleFilterChange}
              rowsCount={getSize()}
              minHeight={640}
              enableRowSelect="single"
              rowSelection={{
                showCheckbox: true,
                onRowsSelected,
                selectBy: {
                  isSelectedKey: 'isSelected',
                },
              }}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderAllCustomersList() {
    if (this.state.isLoadingCustomers) {
      return (
        <Spinner />
      );
    }

    const getRows = () => {
      const rows = Data.Selectors.getRows(this.state.allCustomers);
      return rows;
    };

    const getSize = () => {
      const rowLength = getRows().length;
      return rowLength;
    };

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const allCustomers = { ...this.state.allCustomers, sortColumn, sortDirection };
      this.setState({ allCustomers });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.allCustomers.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const allCustomers = { ...this.state.allCustomers, filters: newFilters };
      this.setState({ allCustomers });
    };

    const onClearFilters = () => {
      const allCustomers = { ...this.state.allCustomers, filters: {} };
      this.setState({ allCustomers });
    };

    const columns = [
      {
        key: 'CustomerNum',
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 140,
        filterable: true,
      },
      {
        key: 'Name',
        name: <Translate value="name" />,
        resizable: true,
        sortable: true,
        width: 250,
        filterable: true,
      },
    ];

    return (
      <Row>
        <Col sm={12}>
          <div id="GroupList-dataGrid2">
            <ReactDataGrid
              rowKey="Product_id"
              onGridSort={handleGridSort}
              toolbar={<Toolbar enableFilter />}
              columns={columns}
              onClearFilters={onClearFilters}
              onAddFilter={handleFilterChange}
              rowHeight={25}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              minHeight={640}
              rowRenderer={<RowRenderer onDoubleClick={this.moveToCustomerGroup} />}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderCustomersInGroupsList() {
    const that = this;
    if (this.state.isLoadingGroupDetails) {
      return (
        <div className="customer-list-spinner">
          <Spinner />
        </div>
      );
    }

    const getRows = () => {
      const rows = Data.Selectors.getRows(this.state.customers);
      return rows;
    };

    const getSize = () => {
      const rowLength = getRows().length;
      return rowLength;
    };

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const customers = { ...this.state.customers, sortColumn, sortDirection };
      this.setState({ customers });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.customers.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const customers = { ...this.state.customers, filters: newFilters };
      this.setState({ customers });
    };

    const onClearFilters = () => {
      const customers = { ...this.state.customers, filters: {} };
      this.setState({ customers });
    };

    const IsVariableFormatter = React.createClass({
      render() {
        return (
          <span>
            <Button
              bsStyle="danger"
              className="textAlignStyle"
              style={{ height: '23px', width: '39px', padding: '0px' }}
              onClick={() => {
                const customerId = this.props.dependentValues.Customer_id;
                const customerNum = this.props.dependentValues.CustomerNum;
                that.removeCustomer(customerId, customerNum);
              }}
            >
              X
            </Button>
          </span>
        );
      },
    });

    const columns = [
      {
        name: <Translate value="del" />,
        width: 50,
        formatter: IsVariableFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'CustomerNum',
        name: <Translate value="cust_no" />,
        resizable: true,
        sortable: true,
        width: 140,
        filterable: true,
      },
      {
        key: 'Name',
        name: <Translate value="name" />,
        resizable: true,
        sortable: true,
        width: 250,
        filterable: true,
      },
    ];

    return (
      <Row>
        <Col sm={12}>
          <div id="GroupList-dataGrid3">
            <ReactDataGrid
              rowKey="Product_id"
              onGridSort={handleGridSort}
              toolbar={<Toolbar enableFilter />}
              columns={columns}
              onClearFilters={onClearFilters}
              onAddFilter={handleFilterChange}
              rowHeight={25}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              minHeight={640}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderCurrentCustomer() {
    if (this.state.currentGroupId == null) {
      return (
        <h2 style={{ marginTop: '5px' }} id="choose-customer"> - <Translate value="msg_select_a_group" /></h2>
      );
    }
    return (
      <h2 style={{ marginTop: '5px' }}> - {this.state.currentGroupName}</h2>
    );
  }

  render() {
    const style = {
      NotificationItem: { // Override the notification item
        DefaultStyle: { // Applied to every notification, regardless of the notification level
          margin: '10px 5px 2px 1px',
        },

        success: { // Applied only to the success notification item
          color: 'red',
        },
      },
    };
    const createDialogModal = {
      height: '180px',
      width: '480px',
      left: '65%',
    };
    const createAction = (<Translate value="confirm_create" />);
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="sales_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="group_list" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <Grid id="group-list">
          <Row>
            <Col sm={3}>
              <h1><Translate value="groups" /></h1>
              <Panel className="table-collapse-fix">
                { this.renderCustomerList() }
              </Panel>
            </Col>
            <Col sm={9}>
              <h1 style={{ float: 'left' }}><Translate value="customer_list" /></h1> {this.renderCurrentCustomer()}
              <Panel className="customer-panel">
                <Col sm={6}>
                  { this.renderAllCustomersList() }
                </Col>
                <Col sm={6}>
                  <div className="customer-list-top-bar">
                    <SpinnerButton
                      bsStyle="success"
                      className="save-button"
                      onClick={this.handleSaveCustomerList}
                      disabled={!this.state.currentGroupId || this.state.isLoadingSaveCustomerList}
                      loading={this.state.isLoadingSaveCustomerList}
                      icon="fa-save"
                      translation={<Translate value="save" />}
                    />
                    <input
                      type="text"
                      className="current-group-name-input"
                      value={this.state.currentGroupName}
                      onChange={this.handleCurrentGroupNameChange}
                      disabled={!this.state.currentGroupId}
                    />
                  </div>
                  { this.renderCustomersInGroupsList() }
                </Col>
              </Panel>
            </Col>
          </Row>
          <NotificationSystem ref="notificationSystem" style={style} />
        </Grid>
        <SkyLightStateless
          dialogStyles={createDialogModal}
          isVisible={this.state.confirmModalOpen}
          onCloseClicked={() => { this.closeModalConfirm(); }}
          title={this.state.confirmTitle}
        >
          <ConfirmActionModal
            case={this.state.case}
            caseAction={this.state.caseAction}
            groupName={this.state.currentGroupName}
            closeC={this.closeModalConfirm}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogModal}
          isVisible={this.state.createModalOpen}
          onCloseClicked={() => { this.closeModalCreate(); }}
          title={createAction}
        >
          <CreateGroupModal
            caseAction={this.handleAddGroup}
            closeC={this.closeModalCreate}
          />
        </SkyLightStateless>
      </ContentWrapper>
    );
  }
}

GroupList.contextTypes = contextTypes;

export default GroupList;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/groupList.jsx